import { render, staticRenderFns } from "./StudentsInClass.vue?vue&type=template&id=5cd4c7ac"
import script from "./StudentsInClass.vue?vue&type=script&lang=js"
export * from "./StudentsInClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports